import useFeatureFlag from "../graphql/hooks/useFeatureFlag";

export const useIsBHScreenRbacEnabled = () => {
  const value = useFeatureFlag("ai_interview:rbac");
  return value;
};
